module.exports = __webpack_public_path__ + "img/captain.61625d31.png";